import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { useGetTradeInsQuery } from '../../../store/api/tradeInApi';

const STATUS_COLORS = {
  pending_assessment: 'warning',
  offer_made: 'info',
  accepted: 'primary',
  rejected: 'error',
  completed: 'success',
};

const STATUS_LABELS = {
  pending_assessment: 'Pending Assessment',
  offer_made: 'Offer Made',
  accepted: 'Accepted',
  rejected: 'Rejected',
  completed: 'Completed',
};

export default function TradeInList() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { data, isLoading } = useGetTradeInsQuery({ search: searchTerm });

  const tradeIns = data?.tradeIns || [];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Trade-Ins & Buybacks
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/trade-ins/new')}
        >
          New Trade-In
        </Button>
      </Box>

      <Paper sx={{ width: '100%', mb: 2, p: 2 }}>
        <Box sx={{ display: 'flex', mb: 2, gap: 2 }}>
          <TextField
            size="small"
            placeholder="Search Ticket, Model, IMEI..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ width: 300 }}
          />
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Ticket No.</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Device Model</TableCell>
                <TableCell>IMEI</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">Loading...</TableCell>
                </TableRow>
              ) : tradeIns.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">No trade-in tickets found.</TableCell>
                </TableRow>
              ) : (
                tradeIns.map((ticket) => (
                  <TableRow key={ticket.id}>
                    <TableCell sx={{ fontWeight: 600 }}>{ticket.ticketNumber}</TableCell>
                    <TableCell>{new Date(ticket.createdAt).toLocaleDateString()}</TableCell>
                    <TableCell>{ticket.customer?.name}</TableCell>
                    <TableCell>{ticket.deviceModel}</TableCell>
                    <TableCell>{ticket.deviceImei || '-'}</TableCell>
                    <TableCell>
                      <Chip
                        label={STATUS_LABELS[ticket.status] || ticket.status}
                        color={STATUS_COLORS[ticket.status] || 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={() => navigate(`/trade-ins/${ticket.id}`)}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
